import products from 'data/filo-tag.json'
import prices from 'data/prices.json'
import { setProductIdBasedOnLang } from '../utilities'

export function getTotal(cart, lang){

    
    let intTotal = 0
    
    
    Object.values(cart).forEach( item => {
        const PRODUCT_LANG = setProductIdBasedOnLang(item.id)
        const DATA_LANG = products[PRODUCT_LANG]

        const { variation: { pack }} = DATA_LANG[item.id.toString()]
        const price = prices[pack]

        let intPrice = parseInt(price * 100)
        let intSubtotal = intPrice * parseInt(item.quantity)
        
        intTotal = intTotal + intSubtotal

    })

    let total = parseFloat( ((intTotal * 100 ) / 100) / 100 ).toFixed(2)

    // console.log("total", total)

    return total

}